import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';

const milestones = [
  { year: '2019', title: '爆料网正式上线', desc: '以“权威及时”为宗旨，首推社会热点与生活动态两大频道。' },
  { year: '2021', title: '娱乐资讯频道开通', desc: '覆盖影视、音乐、综艺等领域，构建更完整的资讯矩阵。' },
  { year: '2023', title: '内容核实机制升级', desc: '建立多源交叉核实流程，进一步提升报道的准确性与公信力。' },
  { year: '2026', title: '全端体验焕新', desc: '完成门户改版，实现搜索、筛选、推荐等功能一体化。' },
];

const team = [
  { name: '编辑部', role: '内容把关', icon: 'ri-article-line', desc: '负责选题策划、事实核实与稿件审校，坚守内容底线。' },
  { name: '记者组', role: '一线采访', icon: 'ri-roadster-line', desc: '深入现场，追踪事件第一手信息，还原事情本来面貌。' },
  { name: '数据组', role: '线索研判', icon: 'ri-line-chart-line', desc: '依托数据监测与舆情分析，快速发现值得关注的热点。' },
  { name: '运营组', role: '读者服务', icon: 'ri-customer-service-2-line', desc: '倾听读者声音，优化浏览体验与互动方式。' },
];

const values = [
  { icon: 'ri-shield-check-line', title: '权威', desc: '重要信息多重核实，拒绝未经证实的传言。' },
  { icon: 'ri-flashlight-line', title: '及时', desc: '全天候追踪热点，力争第一时间送达。' },
  { icon: 'ri-book-open-line', title: '深度', desc: '不止于消息，更讲清事件的来龙去脉。' },
  { icon: 'ri-heart-3-line', title: '贴近', desc: '关注民生冷暖，让新闻回归真实的日常。' },
];

export default function AboutPage() {
  return (
    <>
      <Seo
        title="关于我们-爆料网权威新闻爆料"
        description="了解爆料网的定位、发展历程、团队构成与内容使命。我们致力于提供最新、最全面的新闻爆料和事件报道。"
        keywords="关于爆料网,爆料网介绍,新闻爆料平台,团队介绍"
        path="/about"
      />

      <section className="border-b border-background-200 bg-primary-950">
        <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
          <nav aria-label="面包屑导航" className="flex items-center gap-1 text-sm text-background-50/60">
            <Link to="/" className="hover:text-background-50">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-background-50">关于我们</span>
          </nav>
          <h1 className="mt-5 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
            让每一条重要的新闻爆料，都被认真对待
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-background-50/80 md:text-base">
            爆料网是一个聚焦新闻爆料与事件报道的资讯门户。我们相信，信息的价值不仅在于快，更在于准与深。围绕社会热点、娱乐资讯与生活动态，我们持续输出有依据、有温度的报道。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <section className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((value) => (
            <div key={value.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${value.icon} text-xl`} />
              </span>
              <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">{value.title}</h2>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{value.desc}</p>
            </div>
          ))}
        </section>

        <section className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1fr]">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
              <i className="ri-flag-2-line text-primary-500" />
              网站定位与使命
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              我们面向关注社会、娱乐与生活各类新闻的普通读者，目标是把权威、及时的爆料与事件解析，用清晰、好读的方式呈现出来。无论是城市治理的公共议题，还是文娱前沿的口碑风向，抑或与生活息息相关的实用提醒，都能在爆料网找到对应内容。
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              为提升公信力，爆料网建立了多源交叉核实机制：涉及公共利益的报道，须经至少两个独立信源确认后方可发布；对部分待核实信息，我们会明确标注状态，避免误导读者。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/society"
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
              >
                浏览社会热点
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                联系我们
              </Link>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
              <i className="ri-history-line text-secondary-500" />
              发展历程
            </h2>
            <ol className="mt-5 space-y-6">
              {milestones.map((item) => (
                <li key={item.year} className="relative border-l border-background-300 pl-6">
                  <span className="absolute -left-[7px] top-1 h-3.5 w-3.5 rounded-full border-2 border-background-50 bg-accent-500" />
                  <span className="font-heading text-lg font-bold text-primary-700">{item.year}</span>
                  <h3 className="mt-1 text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <p className="mt-1 text-sm leading-6 text-foreground-600">{item.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </section>

        <section className="mt-12">
          <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950">
            <i className="ri-team-line text-primary-500" />
            团队简介
          </h2>
          <p className="mt-2 text-sm text-foreground-600">一支由采编、数据与运营组成的专业团队，支撑爆料网的日常运转。</p>
          <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {team.map((member) => (
              <div key={member.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${member.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{member.name}</h3>
                <span className="mt-1 inline-block rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                  {member.role}
                </span>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{member.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <i className="ri-information-line text-accent-600" />
            免责声明与版权声明
          </h2>
          <div className="mt-4 space-y-3 text-sm leading-7 text-foreground-600">
            <p>
              <strong className="text-foreground-800">免责声明：</strong>
              本网站为演示示例站点，所展示的新闻内容、图片与数据均为虚构的演示信息，不代表任何真实事件、机构或个人。如需了解真实信息，请以官方权威渠道发布为准。
            </p>
            <p>
              <strong className="text-foreground-800">版权声明：</strong>
              本站所载内容（含文字、排版、界面设计等）版权归爆料网所有，未经书面授权，任何单位和个人不得转载、摘编或以其他方式使用。经授权转载的，须注明来源“爆料网”。
            </p>
            <p>
              <strong className="text-foreground-800">线索处理：</strong>
              读者提供的新闻线索，我们将依据线索价值与核实情况进行跟进；对涉及隐私与敏感信息的内容，将依法依规处理并保护提供者权益。
            </p>
          </div>
        </section>
      </div>
    </>
  );
}